import { fileControllerGetDownloadUrl } from "@/lib/gen-api";

export function useFileUrlAction() {
  return {
    getFileUrl: async (fileUuid: string) => {
      const urlResponse = await fileControllerGetDownloadUrl({
        path: {
          fileUuid,
        },
      });

      return urlResponse.data?.url;
    },
  };
}
